import LazyLoad from "vanilla-lazyload";

window.lazyLoadInstance = function () {
  const lazyLoadInstance = new LazyLoad({
  });
}
